import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { avgEngagementRatePlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import {
  dealwithPercentageDate,
  useSetRangeDefaultValue,
} from '../../hooks/init';
import { useIntl } from 'umi';
import './index.scss';
import BubbleCommon, {
  avgEngagementRateFilterTips,
} from '@op/components/BubbleCommon';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
export default function AvgEngagementRateSelect({
  onChange,
  defaultValue,
  filterValue,
  oriDefaultFilter,
  backOriDefaultValue,
  defaultKey,
  lang,
}: SingleCommonType) {
  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      oriDefaultFilter,
      backOriDefaultValue,
      defaultKey: 'avg_engagements_rate',
      subDefaultKey: 'engagements',
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 5%', value: '0-5' },
        { text: '5% ~ 15%', value: '5-15' },
        { text: '15%+', value: '15-' },
      ],
      dealwithDateFunc: dealwithPercentageDate,
    });
  const { formatMessage } = useIntl();

  function getBackParamsValue() {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      const dataItem: { start_engagements: number; end_engagements?: number } =
        {
          start_engagements: Number(start) / 100,
        };
      if (end !== '') {
        dataItem.end_engagements = Number(end) / 100;
      }
      data.push(dataItem);
    }

    return {
      data,
      showHeader,
    };
  }

  useEffect(() => {
    const { data, showHeader } = getBackParamsValue();
    onChange?.(
      'avgEngagementRate',
      commonBackInfo(
        { avg_engagements_rate: data },
        { avgEngagementRate: showHeader },
      ),
    );
  }, [rangeValue, formatMessage]);

  return (
    <BubbleCommon
      placement="top"
      tipsMap={avgEngagementRateFilterTips}
      showIcon={false}
    >
      <div className={`dbo-avg-engagement-rate-wrapper ${diffClassName}`}>
        <CustomFollowerRange
          lang={lang}
          ref={followerRef}
          options={options}
          pointKey={FilterButtonPoint.avgEngagementRate}
          setRangeValue={setRangeValue}
          rangeValue={rangeValue}
          placeholder={avgEngagementRatePlaceholder}
          unit="%"
        ></CustomFollowerRange>
      </div>
    </BubbleCommon>
  );
}
